import React from 'react';
import './hand-block.css';

export default () => (
  <div className="hand-block">
    <div className="body-left" />
    <div className="body body-right" />
    <div className="body hand-1" />
    <div className="body hand-2" />
    <div className="body hand-3" />
    <div className="body hand-4" />
  </div>
);



// WEBPACK FOOTER //
// ./src/blocks/VideoBlock/HandBlock/index.js